
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexQiTy4mI6sXMeta } from "/codebuild/output/src1663069571/src/pages/index.vue?macro=true";
import { default as about2RdbZFQ5ajMeta } from "/codebuild/output/src1663069571/src/pages/about.vue?macro=true";
import { default as dataBAeUZRXX1jMeta } from "/codebuild/output/src1663069571/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionEyvZ1H2YsyMeta } from "/codebuild/output/src1663069571/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningW6lwmuPVoKMeta } from "/codebuild/output/src1663069571/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyG4BD4fs8RPMeta } from "/codebuild/output/src1663069571/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accountCCdfjYSqv1Meta } from "/codebuild/output/src1663069571/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statueAdfhhn8kkmMeta } from "/codebuild/output/src1663069571/src/pages/account-settings/statue.vue?macro=true";
import { default as supporteZA1Hx2PULMeta } from "/codebuild/output/src1663069571/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settings16NaQ3Zku9Meta } from "/codebuild/output/src1663069571/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountO7txVMQ232Meta } from "/codebuild/output/src1663069571/src/pages/activate-account.vue?macro=true";
import { default as companygQEhWlfMomMeta } from "/codebuild/output/src1663069571/src/pages/admin/company.vue?macro=true";
import { default as consents7tm8LIwvvDMeta } from "/codebuild/output/src1663069571/src/pages/admin/consents.vue?macro=true";
import { default as leads9FMyovDmaOMeta } from "/codebuild/output/src1663069571/src/pages/admin/leads.vue?macro=true";
import { default as paymentskTraa6hmL1Meta } from "/codebuild/output/src1663069571/src/pages/admin/payments.vue?macro=true";
import { default as premiumYpWSI3q3QFMeta } from "/codebuild/output/src1663069571/src/pages/admin/premium.vue?macro=true";
import { default as profilesScBzAjXB2dMeta } from "/codebuild/output/src1663069571/src/pages/admin/profiles.vue?macro=true";
import { default as usershdbAukl3h5Meta } from "/codebuild/output/src1663069571/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordF5M7HZhO1XMeta } from "/codebuild/output/src1663069571/src/pages/change-password.vue?macro=true";
import { default as _91id_93mZAfdxUAYqMeta } from "/codebuild/output/src1663069571/src/pages/chat/[id].vue?macro=true";
import { default as ai_46clientzhsj3spUPkMeta } from "/codebuild/output/src1663069571/src/pages/chat/ai.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src1663069571/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexaHIKQStOgTMeta } from "/codebuild/output/src1663069571/src/pages/chat/index.vue?macro=true";
import { default as _91id_93pey3aQyJNRMeta } from "/codebuild/output/src1663069571/src/pages/client/profile/[id].vue?macro=true";
import { default as indexhFJM68vFhtMeta } from "/codebuild/output/src1663069571/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93izYXSjZQkYMeta } from "/codebuild/output/src1663069571/src/pages/contacts/[id].vue?macro=true";
import { default as indexCr09u7kdIiMeta } from "/codebuild/output/src1663069571/src/pages/contacts/index.vue?macro=true";
import { default as contactsgDSiRjzWRZMeta } from "/codebuild/output/src1663069571/src/pages/contacts.vue?macro=true";
import { default as _91userId_93nkTSECw4JDMeta } from "/codebuild/output/src1663069571/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexyfZURwGeKzMeta } from "/codebuild/output/src1663069571/src/pages/login/index.vue?macro=true";
import { default as register_45successARTuI7jiYRMeta } from "/codebuild/output/src1663069571/src/pages/login/register-success.vue?macro=true";
import { default as logintVq8kp3BTuMeta } from "/codebuild/output/src1663069571/src/pages/login.vue?macro=true";
import { default as logoutAWs1fdThFRMeta } from "/codebuild/output/src1663069571/src/pages/logout.vue?macro=true";
import { default as consents5GcjMoX9MOMeta } from "/codebuild/output/src1663069571/src/pages/manager/consents.vue?macro=true";
import { default as integrations9wNbYJC661Meta } from "/codebuild/output/src1663069571/src/pages/manager/integrations.vue?macro=true";
import { default as leadsAcS1WryrdEMeta } from "/codebuild/output/src1663069571/src/pages/manager/leads.vue?macro=true";
import { default as paymentsU4q8c2ogptMeta } from "/codebuild/output/src1663069571/src/pages/manager/payments.vue?macro=true";
import { default as profileTxM3HlE4JPMeta } from "/codebuild/output/src1663069571/src/pages/manager/profile.vue?macro=true";
import { default as team1yj3h8tKSAMeta } from "/codebuild/output/src1663069571/src/pages/manager/team.vue?macro=true";
import { default as indexwj0a8qiaq0Meta } from "/codebuild/output/src1663069571/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientETuP86MtZ5Meta } from "/codebuild/output/src1663069571/src/pages/marketplace/search/[catId].client.vue?macro=true";
import { default as marketplaceDpkWXbq7ttMeta } from "/codebuild/output/src1663069571/src/pages/marketplace.vue?macro=true";
import { default as subscribeF8ODpRYjSfMeta } from "/codebuild/output/src1663069571/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientWR8OHEb0y4Meta } from "/codebuild/output/src1663069571/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientn4fxtHn03LMeta } from "/codebuild/output/src1663069571/src/pages/orders/my.client.vue?macro=true";
import { default as privacybcZc8QsoqyMeta } from "/codebuild/output/src1663069571/src/pages/privacy.vue?macro=true";
import { default as indexs192V0ddqRMeta } from "/codebuild/output/src1663069571/src/pages/recover/index.vue?macro=true";
import { default as successI9hGgqJ6rLMeta } from "/codebuild/output/src1663069571/src/pages/register/success.vue?macro=true";
import { default as _91id_93ejbj5c3jxGMeta } from "/codebuild/output/src1663069571/src/pages/sales/profile/[id].vue?macro=true";
import { default as index3BMwb5g3f3Meta } from "/codebuild/output/src1663069571/src/pages/sales/profile/index.vue?macro=true";
import { default as statueLgRY09sIaDMeta } from "/codebuild/output/src1663069571/src/pages/statue.vue?macro=true";
import { default as successbLfwndCVX0Meta } from "/codebuild/output/src1663069571/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubJIHy2u1SilMeta } from "/codebuild/output/src1663069571/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubJIHy2u1Sil } from "/codebuild/output/src1663069571/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexQiTy4mI6sXMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: about2RdbZFQ5ajMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: about2RdbZFQ5ajMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settings16NaQ3Zku9Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settings16NaQ3Zku9Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src1663069571/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountO7txVMQ232Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountO7txVMQ232Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companygQEhWlfMomMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companygQEhWlfMomMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consents7tm8LIwvvDMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consents7tm8LIwvvDMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leads9FMyovDmaOMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leads9FMyovDmaOMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentskTraa6hmL1Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentskTraa6hmL1Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumYpWSI3q3QFMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumYpWSI3q3QFMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesScBzAjXB2dMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesScBzAjXB2dMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usershdbAukl3h5Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usershdbAukl3h5Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordF5M7HZhO1XMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordF5M7HZhO1XMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/change-password.vue")
  },
  {
    name: "chat-id___en",
    path: "/en/chat/:id()",
    meta: _91id_93mZAfdxUAYqMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/chat/[id].vue")
  },
  {
    name: "chat-id___pl",
    path: "/pl/chat/:id()",
    meta: _91id_93mZAfdxUAYqMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "/en/chat/ai",
    meta: ai_46clientzhsj3spUPkMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1663069571/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat-ai___pl",
    path: "/pl/chat/ai",
    meta: ai_46clientzhsj3spUPkMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1663069571/src/pages/chat/ai.client.vue"))
  },
  {
    name: "chat___en",
    path: "/en/chat",
    meta: indexaHIKQStOgTMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/chat/index.vue")
  },
  {
    name: "chat___pl",
    path: "/pl/chat",
    meta: indexaHIKQStOgTMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/chat/index.vue")
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93pey3aQyJNRMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93pey3aQyJNRMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexhFJM68vFhtMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexhFJM68vFhtMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/client/profile/index.vue")
  },
  {
    name: contactsgDSiRjzWRZMeta?.name,
    path: "/en/contacts",
    meta: contactsgDSiRjzWRZMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93izYXSjZQkYMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexCr09u7kdIiMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsgDSiRjzWRZMeta?.name,
    path: "/pl/contacts",
    meta: contactsgDSiRjzWRZMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93izYXSjZQkYMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexCr09u7kdIiMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93nkTSECw4JDMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93nkTSECw4JDMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexQiTy4mI6sXMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexQiTy4mI6sXMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/index.vue")
  },
  {
    name: logintVq8kp3BTuMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src1663069571/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexyfZURwGeKzMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successARTuI7jiYRMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: logintVq8kp3BTuMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src1663069571/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexyfZURwGeKzMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successARTuI7jiYRMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutAWs1fdThFRMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutAWs1fdThFRMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consents5GcjMoX9MOMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consents5GcjMoX9MOMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrations9wNbYJC661Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrations9wNbYJC661Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsAcS1WryrdEMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsAcS1WryrdEMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsU4q8c2ogptMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsU4q8c2ogptMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileTxM3HlE4JPMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileTxM3HlE4JPMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: team1yj3h8tKSAMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: team1yj3h8tKSAMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/manager/team.vue")
  },
  {
    name: marketplaceDpkWXbq7ttMeta?.name,
    path: "/en/marketplace",
    meta: marketplaceDpkWXbq7ttMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src1663069571/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientETuP86MtZ5Meta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1663069571/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceDpkWXbq7ttMeta?.name,
    path: "/pl/marketplace",
    meta: marketplaceDpkWXbq7ttMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src1663069571/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientETuP86MtZ5Meta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1663069571/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribeF8ODpRYjSfMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribeF8ODpRYjSfMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientWR8OHEb0y4Meta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1663069571/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientWR8OHEb0y4Meta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1663069571/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientn4fxtHn03LMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1663069571/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientn4fxtHn03LMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src1663069571/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacybcZc8QsoqyMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacybcZc8QsoqyMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexs192V0ddqRMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexs192V0ddqRMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src1663069571/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src1663069571/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93ejbj5c3jxGMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93ejbj5c3jxGMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: index3BMwb5g3f3Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: index3BMwb5g3f3Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statueLgRY09sIaDMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statueLgRY09sIaDMeta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successbLfwndCVX0Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successbLfwndCVX0Meta || {},
    component: () => import("/codebuild/output/src1663069571/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubJIHy2u1SilMeta?.name,
    path: "/old-page",
    component: component_45stubJIHy2u1Sil
  }
]